import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';

var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment["LEFT"] = "left";
    HorizontalAlignment["RIGHT"] = "right";
    HorizontalAlignment["SPACE_BETWEEN"] = "space-between";
})(HorizontalAlignment || (HorizontalAlignment = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["TOP"] = "top";
    VerticalAlignment["MIDDLE"] = "middle";
    VerticalAlignment["BOTTOM"] = "bottom";
})(VerticalAlignment || (VerticalAlignment = {}));

const rocheSideBySideCss = ":host{display:block;margin-top:3rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .side-by-side{display:flex}@media (min-width: 20rem){:host .side-by-side{display:block}}@media (min-width: 48rem){:host .side-by-side--right{display:flex;justify-content:flex-end}}@media (min-width: 48rem){:host .side-by-side--left{display:flex;justify-content:flex-start}}@media (min-width: 48rem){:host .side-by-side--space-between{display:flex;justify-content:space-between}}:host .side-by-side--top{align-items:flex-start}:host .side-by-side--middle{align-items:center}:host .side-by-side--bottom{align-items:flex-end}@media (min-width: 48rem){:host ::slotted(*){margin-top:0 !important}}:host .ratio--fifty-fifty ::slotted(*){flex:1}:host .ratio--fifty-fifty ::slotted(roche-accordion-tabs){overflow:hidden}:host ::slotted(*:not(:first-child)){margin-top:1rem}@media (min-width: 48rem){:host ::slotted(*:not(:first-child)){margin-top:0 !important;margin-left:24px}}@media (min-width: 64rem){:host ::slotted(*:not(:first-child)){margin-top:0 !important}}@media (min-width: 48rem){:host([dir=rtl]) ::slotted(*:not(:first-child)){margin-left:0;margin-right:24px}}";
const RocheSideBySideStyle0 = rocheSideBySideCss;

const RocheSideBySide$1 = /*@__PURE__*/ proxyCustomElement(class RocheSideBySide extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.horizontalAlignment = HorizontalAlignment.LEFT;
        this.verticalAlignment = VerticalAlignment.MIDDLE;
        this.equalRatio = false;
    }
    render() {
        const classNames = {
            'ratio--fifty-fifty': this.equalRatio,
            'side-by-side': true,
            'side-by-side--right': this.horizontalAlignment === HorizontalAlignment.RIGHT,
            'side-by-side--space-between': this.horizontalAlignment === HorizontalAlignment.SPACE_BETWEEN,
            'side-by-side--left': this.horizontalAlignment === HorizontalAlignment.LEFT,
            'side-by-side--top': this.verticalAlignment === VerticalAlignment.TOP,
            'side-by-side--middle': this.verticalAlignment === VerticalAlignment.MIDDLE,
            'side-by-side--bottom': this.verticalAlignment === VerticalAlignment.BOTTOM,
        };
        return (h("div", { key: 'c2e3aa1a1456c1e944318b1a249e6d4e6f7185a9', class: classNames }, h("slot", { key: '8b85cfa0c76cc0c922032479939149f54ab31ca0' })));
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    get element() { return this; }
    static get style() { return RocheSideBySideStyle0; }
}, [1, "roche-side-by-side", {
        "horizontalAlignment": [1, "horizontal-alignment"],
        "verticalAlignment": [1, "vertical-alignment"],
        "equalRatio": [4, "equal-ratio"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-side-by-side"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-side-by-side":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSideBySide$1);
            }
            break;
    } });
}

const RocheSideBySide = RocheSideBySide$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSideBySide, defineCustomElement };

//# sourceMappingURL=roche-side-by-side.js.map